import React from "react";
import { NewsArticle } from "../../data/mockNews.js";

interface NewsCardProps {
  article: NewsArticle;
  className?: string;
}

const NewsCard: React.FC<NewsCardProps> = ({ article, className }) => {
  return (
    <a
      href={article.href}
      className={`news-card group block w-[240px] flex-shrink-0 snap-start ${className || ""}`}
    >
      <div className="relative overflow-hidden rounded-lg">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="h-[160px] w-full object-cover"
        />
        {article.videoDuration && (
          <div className="absolute bottom-2 left-2 flex items-center gap-1 rounded bg-black/70 px-2 py-1 text-xs text-white">
            <i className="fas fa-play text-[10px]"></i>
            <span>{article.videoDuration}</span>
          </div>
        )}
      </div>
      <p className="mt-2 line-clamp-2 text-sm leading-tight text-white group-hover:text-meteoyellow-500">
        {article.title}
      </p>
    </a>
  );
};

export default NewsCard;
